// NOTE on APIEndpoints
// - FE only need talk to /graphql instead of specifying the domain name
// - UAT and Prod are the same to keep FE deployment simple. The only difference is domain name

export const env = process.env.NEXT_APP_ENV as 'dev' | 'staging' | 'production';

const APIEndpoints = {
  // to use localhost BE, set NEXT_PUBLIC_WS_URL=ws://localhost:3000 in .env.development.local
  WS_URL: process.env.NEXT_PUBLIC_WS_URL || '/cable',
  // to use localhost BE, set NEXT_PUBLIC_GRAPHQL_URL=http://localhost:3000/graphql in .env.development.local
  GRAPHQL_URL: process.env.NEXT_PUBLIC_GRAPHQL_URL || '/graphql',
  REST_URL: process.env.NEXT_PUBLIC_REST_URL || '',

  // #TODO : Need to edit after getting DevOps support
  WARRANTY_URL:
    process.env.NEXT_PUBLIC_REST_WARRANTY_URL ||
    (env === 'production' ? 'https://baohanh.nanoco.com.vn' : 'https://stag-baohanh.nanoco.com.vn'),
};

if (env !== 'production') {
  console.log('NEXT_APP_ENV', env);
  console.log('APIEndPoints', APIEndpoints);
}

export default APIEndpoints;
